import { downloadFile, post } from 'utils/api';

export const getUptimeReportData = (data) => {
    const page = data.page ? data.page : 1;
    const payload = { ...data };
    delete payload.page;
    return post(`/chargerUptime?page=${parseInt(page)}`, payload);
}

export const downloadUptimeReportData = (data) => {
    const payload = { ...data, excel: true };
    return downloadFile('/chargerUptime', payload);
}

export const uptimeReportData = {
    getUptimeReportData,
    downloadUptimeReportData
}